//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const wordText_ptbr = `longo
comida
manter
sentado
embora
sempre
faz
completo
carta
segundo
hoje
nada
cão
engraçado
mais
conjunto
tomou
próximo
deu
amar
sete
cidade
perguntar
porta
vai
poderio
espetáculo
tentar
comi
vestido
verde
dinheiro
cantar
vez
cama
cedo
crescer
eu
irmã
andar
marrom
oito
chapéu
agora
sentar
quente
comprar
cada
feliz
seis
lavagem
carro
olhos
duro
fora
sono
água`;

export default wordText_ptbr;
